export const getHublyFormFieldMask = (type: string): string | null => {
  if (type === 'cep') return '99999-999';
  if (type === 'date') return '99/99/9999';

  return null;
};

export const getHublyFormFieldError = (type: string): string | null => {
  if (type === 'cep') return 'Esse CEP está incorreto. Verifique, por favor.';

  return null;
};

export const getHublyFormUnmaskedValue = (value: string): string => {
  if (!value) return '';

  return value.replace(/[^0-9a-zA-Z]+/g, '');
};

export const parseHublyFormFieldsToForm = <T = IPlugFormField>(args: {
  requirements: (Omit<IAppRequirement, 'additionalFields'> & {
    additionalFields: Record<string, any> | string;
  })[];
  formData: Record<string, any>;
  onParse?: (
    requirement: Omit<IAppRequirement, 'additionalFields'> & {
      additionalFields: Record<string, any> | string;
    },
    data: { key: string; value: string },
  ) => T;
  keyLabel?: string;
}) => {
  const { requirements, formData, keyLabel = 'label', onParse } = args;

  return Object.entries(formData).map<T>(([key, valueArg]) => {
    const foundRequirement = requirements.find(requirement => requirement.value === key);
    const value = (valueArg as string | undefined) ?? '';

    const additionalFields: Record<string, any> =
      typeof foundRequirement?.additionalFields === 'string'
        ? !foundRequirement?.additionalFields?.length
          ? {}
          : JSON.parse(foundRequirement.additionalFields ?? '{}')
        : foundRequirement?.additionalFields;

    if (onParse)
      return onParse({ ...foundRequirement, additionalFields }, { key, value: valueArg });

    return {
      [keyLabel]: key,
      value: additionalFields?.mask ? getHublyFormUnmaskedValue(value) : value,
    } as T;
  });
};

export const regex = (regex: string) => {
  let trim = regex;

  if (regex.startsWith('/')) trim = trim.substring(1);
  if (regex.endsWith('/')) trim = trim.substring(0, trim.length - 1);

  return RegExp(trim, 'i');
};
